import React from 'react'

import { formatCurrency } from 'utils/formatters'
import { padLeft } from 'utils'

import Button from 'common/Button'
import Card from 'common/Card'
import ReactTable from 'common/ReactTable'

export default ({ resource, piItem, caseCurrency }) => {
  const { documentIndex, lines, totalExclVat, totalInclVat, supplierInvoiceReference, attachmentId } = piItem
  const columns = React.useMemo(
    () => [
      {
        Header: resource.Description,
        accessor: 'description',
        headerClassName: 'col',
        className: 'col',
        footerClassName: 'col text-end fw-bold',
        Cell: ({ value, row }) => (
          <span title={value} className="word-break-break-word white-space-normal">
            {value}
          </span>
        ),
        Footer: () => (
          <div>
            <div className="p-1">{`${resource.TotalExclVat}:`}</div>
            <div className="p-1">{`${resource.TotalInclVat}:`}</div>
          </div>
        ),
      },
      {
        Header: resource.PiAmount,
        accessor: 'amount.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value }) => <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>,
        Footer: () => (
          <div>
            <div className="p-1">{formatCurrency(totalExclVat.value, undefined, caseCurrency.currencySymbol)}</div>            
            <div className="p-1">{formatCurrency(totalInclVat.value, undefined, caseCurrency.currencySymbol)}</div>
          </div>
        ),
      },
    ],
    []
  )

  const fileLink = `${process.env.REACT_APP_API_URL}/file/${attachmentId}`

  return (
    <Card
      outline
      title={
        <div className="mb-lg-0 mb-1 white-space-break-spaces text-lg-start text-center">
          <strong>{`${resource.PurchaseInvoice} ${padLeft(documentIndex, 1)}`}</strong> - {supplierInvoiceReference}
        </div>
      }
      className="position-relative margin-bot-20 col-lg-8 col-md-6 col-12"
      titleClassName="white-space-nowrap flex-lg-row flex-column"
      actions={
        <React.Fragment>
          {!!attachmentId && (
            <Button color="primary" text size="sm" icon="download" onClick={() => window.open(fileLink)}>
              {resource.DownloadInvoice}
            </Button>
          )}
        </React.Fragment>
      }
    >
      <ReactTable columns={columns} data={lines} showFooter responsive />
    </Card>
  )
}
